import template from './create.html';
import { createSubAccount } from '../../../state/accounts/accounts.actions';

export class CreateSubAccountController {

  constructor($ngRedux) {
    'ngInject';

    this.store = $ngRedux;
    this.unsubscribe = this.store.connect(this.mapStateToThis, {createSubAccount})(this);
    this.validationMessage = null; 
  }

  mapStateToThis(state) {
    return {
      loading: state.accounts.creating_subaccount
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  checkNameValidation() {
    let name = this.getFirstCreateAccountName();

    if (name === "" || name.length <= 3) {
      this.setValidationMessage("Name cannot be empty, and must be longer than 3 characters.");
      return;
    }

    this.setValidationMessage(null);
  }

  createFirstSubAccount() {
    if (this.validationMessage === null) {
      this.createSubAccount(this.getFirstCreateAccountName());
    }
  }

  getFirstCreateAccountName() {
    return document.getElementById('first_sub_account_name').value.trim();
  }

  setValidationMessage(message) {
    this.validationMessage = message;
  }
}

export default {
  template,
  replace: true,
  controller: CreateSubAccountController,
  controllerAs: 'vm'
};